import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className='container mt-3' style={{ backgroundColor: '', fontFamily: 'Open Sans-Serif', width: "90%", marginLeft: "auto", marginRight: "auto", padding: "20px" }}>
    <div className="card-title"> <h3 className='display-4 ml-3' style={{color: 'blue'}}>Privacy Policy</h3></div>
     
      <div className='card ml-3'>
      <div className="ml-3">
      <br/>  <span><u className="display-5 lead">A. Introduction</u></span> <br/> The privacy of our website visitors is very important to
        us, and we are committed to safeguarding it. This policy explains what
        we will do with your personal information. Consenting to our use of
        cookies in accordance with the terms of this policy when you first visit
        our website permits us to use cookies every time you visit our website.
        <br /><br/> 
        <span><u className="display-5 lead">B. Credit</u></span>  <br />This document was created using a template from SEQ Legal
        (seqlegal.com) and modified by Website Planet (www.websiteplanet.com)
        <br /> <br/> 
        <span><u className="display-5 lead">C. Collecting personal information</u></span> <br />The following types of personal
        information may be collected, stored, and used: information about your
        computer including your IP address, geographical location, browser type
        and version, and operating system; information about your visits to and
        use of this website including the referral source, length of visit, page
        views, and website navigation paths; information, such as your email
        address, that you enter when you register with our website; information
        that you enter when you create a profile on our website—for example,
        your name, profile pictures, gender, birthday, relationship status,
        interests and hobbies, educational details, and employment details;
        information, such as your name and email address, that you enter in
        order to set up subscriptions to our emails and/or newsletters;
        information that you enter while using the services on our website;
        information that is generated while using our website, including when,
        how often, and under what circumstances you use it; information relating
        to anything you purchase, services you use, or transactions you make
        through our website, which includes your name, address, telephone
        number, email address, and credit card details; information that you
        post to our website with the intention of publishing it on the internet,
        which includes your username, profile pictures, and the content of your
        posts; information contained in any communications that you send to us
        by email or through our website, including its communication content and
        metadata; any other personal information that you send to us. Before you
        disclose to us the personal information of another person, you must
        obtain that person’s consent to both the disclosure and the processing
        of that personal information in accordance with this policy
        <br />
        <br/>   <span><u className="display-5 lead"> D. Using your personal information</u></span>  <br /> Personal information submitted to us
        through our website will be used for the purposes specified in this
        policy or on the relevant pages of the website. We may use your personal
        information for the following: administering our website and business;
        personalizing our website for you; enabling your use of the services
        available on our website; sending you goods purchased through our
        website; supplying services purchased through our website; sending
        statements, invoices, and payment reminders to you, and collecting
        payments from you; sending you non-marketing commercial communications;
        sending you email notifications that you have specifically requested;
        sending you our email newsletter, if you have requested it (you can
        inform us at any time if you no longer require the newsletter); sending
        you marketing communications relating to our business or the businesses
        of carefully-selected third parties which we think may be of interest to
        you, by post or, where you have specifically agreed to this, by email or
        similar technology (you can inform us at any time if you no longer
        require marketing communications); providing third parties with
        statistical information about our users (but those third parties will
        not be able to identify any individual user from that information);
        dealing with inquiries and complaints made by or about you relating to
        our website; keeping our website secure and prevent fraud; verifying
        compliance with the terms and conditions governing the use of our
        website (including monitoring private messages sent through our website
        private messaging service); and other uses. If you submit personal
        information for publication on our website, we will publish and
        otherwise use that information in accordance with the license you grant
        to us. Your privacy settings can be used to limit the publication of
        your information on our website and can be adjusted using privacy
        controls on the website. We will not, without your express consent,
        supply your personal information to any third party for their or any
        other third party’s direct marketing. <br /> <br/>    <span><u className="display-5 lead"> E. Disclosing personal
        information </u></span> <br /> We may disclose your personal information to any of our
        employees, officers, insurers, professional advisers, agents, suppliers,
        or subcontractors as reasonably necessary for the purposes set out in
        this policy. We may disclose your personal information to any member of
        our group of companies (this means our subsidiaries, our ultimate
        holding company and all its subsidiaries) as reasonably necessary for
        the purposes set out in this policy. We may disclose your personal
        information: to the extent that we are required to do so by law; in
        connection with any ongoing or prospective legal proceedings; in order
        to establish, exercise, or defend our legal rights (including providing
        information to others for the purposes of fraud prevention and reducing
        credit risk); to the purchaser (or prospective purchaser) of any
        business or asset that we are (or are contemplating) selling; and to any
        person who we reasonably believe may apply to a court or other competent
        authority for disclosure of that personal information where, in our
        reasonable opinion, such court or authority would be reasonably likely
        to order disclosure of that personal information. Except as provided in
        this policy, we will not provide your personal information to third
        parties. <br/> <br/> <span><u className="display-5 lead"> F. International data transfers </u></span> <br />Information that we collect may
        be stored, processed in, and transferred between any of the countries in
        which we operate in order to enable us to use the information in
        accordance with this policy. Information that we collect may be
        transferred to the following countries which do not have data protection
        laws equivalent to those in force in the European Economic Area: the
        United States of America, Russia, Japan, China, and India. Personal
        information that you publish on our website or submit for publication on
        our website may be available, via the internet, around the world. We
        cannot prevent the use or misuse of such information by others. You
        expressly agree to the transfers of personal information described in
        this Section <br /> <br/> <span><u className="display-5 lead"> G. Retaining personal information </u></span> <br />This Section G
        sets out our data retention policies and procedure, which are designed
        to help ensure that we comply with our legal obligations regarding the
        retention and deletion of personal information. Personal information
        that we process for any purpose or purposes shall not be kept for longer
        than is necessary for that purpose or those purposes. Without prejudice
        to article G-2, we will usually delete personal data falling within the
        categories set out below at the date/time set out below: personal data
        type will be deleted 2020; and 2020. Notwithstanding the other
        provisions of this Section G, we will retain documents including
        electronic documents containing personal data: to the extent that we are
        required to do so by law; if we believe that the documents may be
        relevant to any ongoing or prospective legal proceedings; and in order
        to establish, exercise, or defend our legal rights including providing
        information to others for the purposes of fraud prevention and reducing
        credit risk). <br /> <br/> <span><u className="display-5 lead"> H. Security of your personal information </u></span> <br /> We will take
        reasonable technical and organizational precautions to prevent the loss,
        misuse, or alteration of your personal information. We will store all
        the personal information you provide on our secure password- and
        firewall-protected servers. All electronic financial transactions
        entered into through our website will be protected by encryption
        technology. You acknowledge that the transmission of information over
        the internet is inherently insecure, and we cannot guarantee the
        security of data sent over the internet. You are responsible for keeping
        the password you use for accessing our website confidential; we will not
        ask you for your password except when you log in to our website. I.
        Amendments We may update this policy from time to time by publishing a
        new version on our website. You should check this page occasionally to
        ensure you understand any changes to this policy. We may notify you of
        changes to this policy by email or through the private messaging system
        on our website.
        </div>
      </div>
      </div>
   
  );
};

export default PrivacyPolicy;